import { FC } from "react";

import TableVacantRoutes from "../../table/recruiting/tableVacantRoutesList";

interface ISectionOptions {
  title?: string;
}

const AddRouteOnVacancySection: FC<ISectionOptions> = () => {
  return (
    <div>
      <TableVacantRoutes inModal={true} />
    </div>
  );
};

export default AddRouteOnVacancySection;
